import apiClient from "./client";

export function getActiveAlerts() {
  return apiClient.get("/iot/alerts/active").then((res) => res.data);
}

export function getAlertsForDevice(deviceId) {
  return apiClient
    .get(`/iot/alerts/device/${encodeURIComponent(deviceId)}`)
    .then((res) => res.data);
}

export function createAlert(alert) {
  return apiClient.post("/iot/alerts", alert).then((res) => res.data);
}

export function acknowledgeAlert(alertId, userId) {
  return apiClient
    .post(`/iot/alerts/${alertId}/acknowledge`, { userId })
    .then((res) => res.data);
}

export function resolveAlert(alertId) {
  return apiClient
    .post(`/iot/alerts/${alertId}/resolve`)
    .then((res) => res.data);
}

export function getAlertRules(deviceId) {
  const params = deviceId ? { deviceId } : {};
  return apiClient.get("/iot/alerts/rules", { params }).then((res) => res.data);
}

export function createAlertRule(rule) {
  return apiClient.post("/iot/alerts/rules", rule).then((res) => res.data);
}

export function updateAlertRule(ruleId, rule) {
  return apiClient
    .put(`/iot/alerts/rules/${ruleId}`, rule)
    .then((res) => res.data);
}

export function deleteAlertRule(ruleId) {
  return apiClient.delete(`/iot/alerts/rules/${ruleId}`).then((res) => res.data);
}

export function checkDeviceAlerts(deviceId) {
  return apiClient
    .post(`/iot/alerts/check/${encodeURIComponent(deviceId)}`)
    .then((res) => res.data);
}

export function checkAllDevicesAlerts() {
  return apiClient.post("/iot/alerts/check-all").then((res) => res.data);
}
